import { Col, Container, Row } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import useCustom from "../../hooks/useCustom";

const Faqs = ({show, faqs: propFaqs}) => {
  const {
    faq: hookFaq
  } = useCustom();

  // Use prop FAQs if provided, otherwise fallback to hook FAQs
  const faqData = propFaqs && propFaqs.length > 0 ? propFaqs : hookFaq;

  return (
    <Container>
      {show && <h2 className="sds-activitiy-title mb-md-5 mb-3">FAQ's</h2>} 

      <Accordion>
        {faqData && faqData.length > 0 ? (
          faqData.map((faqItem, index) => {
            // Use serial number based on filtered list position (1, 2, 3...)
            const serialNumber = String(index + 1).padStart(2, '0');
            const question = faqItem.question || '';
            const answer = faqItem.answer || '';

            return (
              <Accordion.Item eventKey={index} key={faqItem.id || index}>
                <Accordion.Header>
                  <div className="w-100">
                    <Row>
                      <Col xs={12} lg={12} className="position-relative">
                        <h1 className="accordian-title count mt-1 position-absolute">{serialNumber}</h1>
                        <h1 className="accordian-title">{question}</h1>
                      </Col>
                    </Row>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="faq-content" dangerouslySetInnerHTML={{ __html: answer }} />
                </Accordion.Body>
              </Accordion.Item>
            );
          })
        ) : (
          <div className="text-center py-4">
            <p className="text-muted">No FAQs available.</p>
          </div>
        )}
      </Accordion>
    </Container>
  );
};

export default Faqs;